/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")


  
    
export interface API47902Item {
  
  /** 任务id */
  taskId?: number;
  
  /** 任务动态 */
  content?: string;
  
  /** 操作人id */
  operatorId?: string;
  
  /** 操作人姓名 */
  operatorName?: string;
  
  /** 操作时间 */
  optTime?: any;
  
  /** 头像 */
  headIconUrl?: string;
  
};
    
  



export interface API47902Req {
  
  /** 任务id */
  taskId?: string;
    
};



export interface API47902Res {
  /** T  */
  list?: API47902Item[];
  /**   */
  totalNumber?: any;
  /**   */
  totalPage?: any;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: any;
  /**   */
  pageIndex?: any;
  
};


// 47902 任务日志

export interface IUseGetAPI47902Return {
  /** 任务日志: 接口请求状态 */
  isAPI47902Loading: boolean;
  /** 任务日志: 接口请求返回数据 */
  dataAPI47902: API47902Res;
  /**  任务日志: 接口数据请求方法 */
  fetchAPI47902Data:  (inputs: API47902Req, config?: YWRequestConfig) => Promise<API47902Res>;
  /** 任务日志: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI47902 = ():IUseGetAPI47902Return => {
  let isMount = true;
  const [isAPI47902Loading, setIsAPI47902Loading] = useState(false);
  const [dataAPI47902, setDataAPI47902] = useState<API47902Res>({} as API47902Res);
  const requestUrl = `${basePath}/corp-admin/project/plan/task/log`;

  const fetchAPI47902Data = async (inputs: API47902Req, config?: YWRequestConfig): Promise<API47902Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API47902Req>) || {}) as API47902Req;
    
  
    if ( isMount ) {
      setIsAPI47902Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API47902Res>(`${basePath}/corp-admin/project/plan/task/log?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI47902(res || {} as API47902Res);
        setIsAPI47902Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI47902Loading(false);
      }
      return false as unknown as API47902Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI47902Loading,
    dataAPI47902,
    fetchAPI47902Data,
    requestUrl,
  }
}

